import { V004Algorithm } from '../../../../Algorithm';
import { KeySystemPasswordType, ProtocolVersion, } from '@standardnotes/models';
import { DeriveKeySystemRootKeyUseCase } from './DeriveKeySystemRootKey';
export class CreateRandomKeySystemRootKey {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(dto) {
        const version = ProtocolVersion.V004;
        const seed = this.crypto.generateRandomKey(V004Algorithm.ArgonSaltSeedLength);
        const randomPassword = this.crypto.generateRandomKey(32);
        const keyParams = {
            systemIdentifier: dto.systemIdentifier,
            passwordType: KeySystemPasswordType.Randomized,
            creationTimestamp: new Date().getTime(),
            seed,
            version,
        };
        const usecase = new DeriveKeySystemRootKeyUseCase(this.crypto);
        return usecase.execute({
            password: randomPassword,
            keyParams,
        });
    }
}
